const LOGMAN_SERVICE_NAME = "wildcraft";

export { LOGMAN_SERVICE_NAME };
